module.exports = __webpack_public_path__ + "165174aeabe00f499da11ec835c58e05.svg";